export default Object.freeze({
    NEW: 1,
    GENERATED_FILE: 2,
    SUBMITTED: 3,
    AMENDED: 4,
    PUBLISHED: 5
})
